import type { FC } from "react";

import { swSettings } from "app/common/services/swSettings";
import WWOSearchTrafficPaid from "app/pages/website-performance/components/SearchTraffic/paid/WWOSearchTrafficPaid";
import {
    getAdsCtaLinkForDS,
    getKeywordsCtaLinkForDS,
} from "app/pages/website-performance/components/SearchTraffic/utlis";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";
import { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";
import { getHooksVersion } from "app/UtilitiesAndConstants/UtilityFunctions/hooksUtils";
import { isNoTouchOrTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export const WWOSearchTrafficPaidContainerDS: FC = () => {
    const isEligibleForFeatureHookModal = isNoTouchOrTrialOrAfterTrial(swSettings);
    return (
        <WWOSearchTrafficPaid
            getKeywordsCtaLink={(params) =>
                getKeywordsCtaLinkForDS({
                    ...params,
                    selectedPageTab: EKeywordTabs[EKeywordTabs.Paid],
                })
            }
            getAdsCtaLink={getAdsCtaLinkForDS}
            adsUnlockHook={{
                component: "WsWebSearchAds",
                hookModal: isEligibleForFeatureHookModal ? "publisherOverview" : DEFAULT_HOOKS_MODAL_ID,
                version: getHooksVersion(swSettings),
            }}
            keywordsUnlockHook={{
                component: "WsWebSearchKeywords",
                hookModal: isEligibleForFeatureHookModal ? "keywordResearch" : DEFAULT_HOOKS_MODAL_ID,
                version: getHooksVersion(swSettings),
            }}
        />
    );
};
